var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const getImpressionLoggingEndpoint = () => {
    const { IMPRESSION_LOG_DOMAIN } = process.env;
    return `${IMPRESSION_LOG_DOMAIN}/log_data/log`;
};
const getCommonFieldsForImpressions = (deviceType, logger) => {
    try {
        return {
            platform: deviceType,
            vertical: window.location.host,
            app_version: '',
            device_model: navigator.userAgent || '',
            session_id: '',
            mc_id: (window.s && window.s.marketingCloudVisitorID) || '',
            timestamp: (new Date().getTime() / 1000),
            source: 'web-sdk',
        };
    }
    catch (err) {
        logger.error(err, 'Error getting common Fields');
        return {};
    }
};
const handleImpressions = (impressions, customerId = '', deviceType = '', logger, ApiHelper) => __awaiter(void 0, void 0, void 0, function* () {
    const updatedImpressions = impressions.map((impression) => {
        const newImpression = impression;
        delete newImpression.pageName;
        delete newImpression.pageId;
        delete newImpression.sessionId;
        if (!newImpression.timestamp) {
            newImpression.timestamp = ((+new Date()) / 1000);
        }
        return newImpression;
    });
    const data = {
        events: updatedImpressions,
        common_fields: Object.assign(Object.assign({}, getCommonFieldsForImpressions(deviceType, logger)), { customer_id: customerId }),
    };
    const url = getImpressionLoggingEndpoint();
    const securityOptions = { CSRF: false };
    try {
        const response = yield ApiHelper(url, 'post', data, undefined, securityOptions);
        let status = 1;
        /*
          This is to handle cases around different ApiHelper(s)
          Axios returns status as response.data.status(used by Beauty)
          While, Fetch returns status as response.status(used by Fashion)
        */
        if (response && response.data) {
            status = response.data.status;
        }
        else if (response) {
            status = response.status;
        }
        if (!status || status !== 1) {
            throw new Error(`Impression log returned a status !== 1: ${status}`);
        }
    }
    catch (err) {
        logger.error(err, 'Error Posting data for impressions');
        throw err;
    }
});
export default handleImpressions;
